import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { ErrorHandler } from "../../../Helpers/ErrorHandler";
import searchService from "../../../Services/searchService";

export const useSearchProduct = (text: string | undefined) => {
  return useQuery(["products"], () => searchService.searchProduct(text), {
    enabled: true,
    retry: 1,
    select: (data: { data: { data: any[] } }) => data.data.data,
    onSuccess(data) {
      // toast.success("success", { duration: 20000, className: 'custom-alert bg-white text-dark', position: "top-right" });
    },
    onError(error: any) {
      if (Array.isArray((error as any).data.error)) {
        (error as any).data.error.forEach((el: any) =>
          ErrorHandler(error, () => {
            toast.error(error.response.data.error, {
              duration: 20000,
              className: "custom-alert bg-white text-dark",
              position: "top-right",
            });
          })
        );
      } else {
        ErrorHandler(error, () => {
          toast.error(error.response.data.error, {
            duration: 20000,
            className: "custom-alert bg-white text-dark",
            position: "top-right",
          });
        });
      }
    },
  });
};
